export const $win = $(window);
export const $doc = $(document);
export const $header = $('.header');
export const $wrapper = $('.wrapper');
export const $main = $('.main');
export const $hero = $('.hero');

export const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date);
}

export function getCurrentDevice(){
	let currentDevice = 'desktop';
	if ($win.width() <= 767) {
		currentDevice = 'mobile'
	} else if ($win.width() < 1200) {
		currentDevice = 'tablet'
	} else {
		currentDevice = 'desktop'
	}
	return currentDevice;
}

export const keys = {
	end: 35,
	home: 36,
	left: 37,
	up: 38,
	right: 39,
	down: 40,
	delete: 46,
	enter: 13,
	space: 32,
	tab: 9,
	escape: 27
};

export function videoControlPlayer($iframe, state) {
	let iframeSrc = $iframe.attr('src');
	if (!iframeSrc) return
	iframeSrc = iframeSrc.replace('#play', '')
						 .replace('#pause', '');
	$iframe.attr('src', `${iframeSrc}#reset`);
	setTimeout(function(){
		$iframe.attr('src', `${iframeSrc}#${state}`)
	}, 100);
	$iframe.attr('src', `${iframeSrc}#${state}`)
}

export function mapOffsetCenter(map, latlng, offsetx, offsety) {
	const scale = Math.pow(2, map.getZoom());
	const nw = new google.maps.LatLng(
	map.getBounds().getNorthEast().lat(), map.getBounds().getSouthWest().lng());

	const worldCoordinateCenter = map.getProjection().fromLatLngToPoint(latlng);
	const pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0)

	const worldCoordinateNewCenter = new google.maps.Point(
	worldCoordinateCenter.x - pixelOffset.x, worldCoordinateCenter.y + pixelOffset.y);

	const newCenter = map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

	map.setCenter(newCenter);
}

export const getElementPosition = container => {
    const offset = $(container).offset().top;
    const scrolltop = $(window).scrollTop();
    const windowH = $(window).height();

	return offset - scrolltop > windowH / 1.8 ? 'top' : 'bottom';
}

/*
How to use

loadScript('yourScriptName', window.yourScriptName, function() {
	return new Promise((resolve, reject) => {
		yourCoolFunction();

		resolve();
	})
})
*/

$.cachedScript = (url, options) => {
	// Allow user to set any option except for dataType, cache, and url
	options = $.extend( options || {}, {
		dataType: "script",
		cache: true,
		url: url
	});
   
	// Use $.ajax() since it is more flexible than $.getScript
	// Return the jqXHR object so we can chain callbacks
	return $.ajax(options);
};

const isScriptLoaded = {};

export function loadScript(shortName, scriptPath, callback) {	
	if (!shortName in isScriptLoaded) isScriptLoaded[shortName] = false;

	return new Promise(resolve => {
		if (shortName in isScriptLoaded) {
			callback();
		} else {
			$.cachedScript(scriptPath).done(() => {
				isScriptLoaded[shortName] = true;
	
				callback().then(() => {
					resolve();
				})
			});
		}
	});
}
